import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import compose from 'recompose/compose'

import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { Card, CardHeader, CardContent, Grid, Typography, Button, ListItemIcon, Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress, TextField, Chip, Checkbox, FormControlLabel } from '@material-ui/core'
import { Snooze, Warning } from '@material-ui/icons'
import ClassroomSidebar from './Components/ClassroomSidebar'
import { usergroupActions } from '_state/actions'
import ListItem from '@material-ui/core/ListItem'
import List from '@material-ui/core/List'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import Avatar from '@material-ui/core/Avatar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { userActions } from '_state/actions/user.actions'
import moment from 'moment/moment'
import { organizationActions } from '../../../_state/actions'
import { UserStatisticsVisibility } from '../CapeeshConstants'
import DayOfTheWeekPieChart from '../../../Components/Graphs/DayOfTheWeekPieChart'
import HourOfDayGraph from '../../../Components/Graphs/HourOfDayGraph'
import Footer from '../../../Components/Footer'
import { FormattedMessage } from 'react-intl'
import CourseGroupCard from '../../../Components/CourseGroupCard/CourseGroupCard'

const styles = (theme) => ({
    root: {
        minHeight: '300px',
        marginLeft: 'calc(15% + 25px)',
        marginRight: '25px',
    },
    button: {
        margin: theme.spacing(1),
    },
    graph: {
        marginTop: 20,
    },
    leaderBoardIndex: {
        background: theme.palette.primary.main,
    },
})

class ClassroomDashboard extends React.Component {
    state = {
        leaderBoardTab: 0,
        courseGroupModalOpen: false,
        selectedCourseGroupIds: [],
        includePassedColumn: true,
        includeClassroomColumn: false,
        exportFromDate: '',
        exportToDate: '',
        selectedDatePreset: 'all',
    }

    componentDidMount = () => {
        const { computedMatch, dispatch, organization } = this.props
        dispatch(
            usergroupActions.getUserGroupStats(organization.selectedOrganization, computedMatch.params.classroomId)
        )
        dispatch(
            organizationActions.getGraphDataDayOfWeekUserGroup(
                organization.selectedOrganization,
                computedMatch.params.classroomId
            )
        )
        dispatch(
            organizationActions.getGraphDataHourlyUserGroupId(
                organization.selectedOrganization,
                computedMatch.params.classroomId
            )
        )
        dispatch(
            organizationActions.getGraphDataDailyUsageAggregatedUserGroup(
                organization.selectedOrganization,
                computedMatch.params.classroomId
            )
        )
    }

    getClassroomExcelReportFromTemplate = () => {
        let date = moment(moment.now()).format('YYYY-MM-DD')
        const { usergroup, computedMatch, dispatch, organization } = this.props
        var filename = 'Classroom Report for ' + computedMatch.params.classroomId + ' ' + date + '.xlsx'
        var currentUserGroup = usergroup.usergroups.find((x) => x.id === computedMatch.params.classroomId)
        var currentOrganization = organization.myOrganizations.find((x) => x.id === organization.selectedOrganization)

        if (currentUserGroup) {
            filename = 'Classroom Report for ' + currentUserGroup.name + ' ' + date + '.xlsx'
        }
        dispatch(
            organizationActions.exportExcelFromTemplateClassroomStats(
                currentOrganization.id,
                computedMatch.params.classroomId,
                filename
            )
        )
    }

    openCourseGroupModal = () => {
        const { dispatch, organization } = this.props
        dispatch(organizationActions.getOrganizationCourseGroups(organization.selectedOrganization))
        this.setState({
            courseGroupModalOpen: true,
            selectedCourseGroupIds: [],
            exportFromDate: '',
            exportToDate: '',
            selectedDatePreset: 'all',
            includePassedColumn: true,
            includeClassroomColumn: false,
        })
    }

    closeCourseGroupModal = () => {
        this.setState({ courseGroupModalOpen: false })
    }

    handleDatePreset = (preset) => {
        const now = moment()
        let fromDate = ''
        let toDate = now.format('YYYY-MM-DD')
        if (preset === 'all') {
            fromDate = ''
            toDate = ''
        } else if (preset === '7d') {
            fromDate = now.clone().subtract(7, 'days').format('YYYY-MM-DD')
        } else if (preset === '30d') {
            fromDate = now.clone().subtract(30, 'days').format('YYYY-MM-DD')
        } else if (preset === '90d') {
            fromDate = now.clone().subtract(90, 'days').format('YYYY-MM-DD')
        } else if (preset === 'year') {
            fromDate = now.clone().startOf('year').format('YYYY-MM-DD')
        }
        this.setState({ exportFromDate: fromDate, exportToDate: toDate, selectedDatePreset: preset })
    }

    handleToggleCourseGroup = (courseGroupId) => {
        this.setState((prevState) => {
            const isSelected = prevState.selectedCourseGroupIds.includes(courseGroupId)
            return {
                selectedCourseGroupIds: isSelected
                    ? prevState.selectedCourseGroupIds.filter((id) => id !== courseGroupId)
                    : [...prevState.selectedCourseGroupIds, courseGroupId],
            }
        })
    }

    handleToggleSelectAll = () => {
        const { organization } = this.props
        const allIds = organization.organizationCourseGroups?.map((cg) => cg.id) || []
        if (this.state.selectedCourseGroupIds.length === allIds.length) {
            this.setState({ selectedCourseGroupIds: [] })
        } else {
            this.setState({ selectedCourseGroupIds: allIds })
        }
    }

    handleExportCourseGroupProgression = () => {
        const { dispatch, organization, computedMatch, usergroup, user } = this.props
        const { selectedCourseGroupIds, exportFromDate, exportToDate, includePassedColumn, includeClassroomColumn } =
            this.state

        if (selectedCourseGroupIds.length === 0) return

        let date = moment(moment.now()).format('YYYY-MM-DD')
        var currentUserGroup = usergroup.usergroups.find((x) => x.id === computedMatch.params.classroomId)
        var filename = 'Course Group Progression ' + (currentUserGroup?.name || computedMatch.params.classroomId) + ' ' + date + '.xlsx'

        const fromDate = exportFromDate ? new Date(exportFromDate).toISOString() : undefined
        const toDate = exportToDate ? new Date(exportToDate + 'T23:59:59').toISOString() : undefined

        dispatch(
            organizationActions.exportCourseGroupProgressionClassroom(
                organization.selectedOrganization,
                selectedCourseGroupIds,
                computedMatch.params.classroomId,
                filename,
                fromDate,
                toDate,
                user.userDashboardLanguageId || 1,
                {
                    includePassed: includePassedColumn,
                    includeClassroom: includeClassroomColumn,
                }
            )
        )
        this.setState({ courseGroupModalOpen: false })
    }

    resendInvite = (event) => {
        const { dispatch, usergroup, organization } = this.props
        const usersNotSignedUp = usergroup.userGroupStats.users.filter(
            (x) => x.signUpDate == '0001-01-01T00:00:00+00:00'
        )
        usersNotSignedUp.forEach((element) => {
            dispatch(userActions.resendInvite(organization.selectedOrganization, element.userId))
        })
    }

    createActionPoint = (userGroupStats, showEngagementButtons, showNotActiveLast7Days) => {
        let actionCards = []

        if (!userGroupStats?.users) return actionCards

        const usersSignedUp = userGroupStats.users.filter((x) => x.signUpDate != '0001-01-01T00:00:00+00:00')
        const usersNotSignedUp = userGroupStats.users.filter((x) => x.signUpDate == '0001-01-01T00:00:00+00:00')
        const usersNotActiveInLast7Days = usersSignedUp.filter((x) => x.hasActivityLast7Days)

        if (usersNotSignedUp?.length > 0) {
            actionCards.push(
                <ListItem key="usersNotSignedUp">
                    <ListItemIcon>
                        <Warning color="primary" />
                    </ListItemIcon>
                    <ListItemText
                        primary={
                            <FormattedMessage
                                id="dashboard.classroom.dash.usersnotsignedupyet"
                                defaultMessage="users have not signed up yet">
                                {(usersNotSignedUpYetText) => usersNotSignedUp.length + ' ' + usersNotSignedUpYetText}
                            </FormattedMessage>
                        }
                    />
                    {showEngagementButtons && (
                        <ListItemSecondaryAction>
                            <Button variant="contained" onClick={() => this.resendInvite()}>
                                <FormattedMessage id="globalwords.sendreminder" defaultMessage="Send reminder" />
                            </Button>
                        </ListItemSecondaryAction>
                    )}
                </ListItem>
            )
        }
        if (showNotActiveLast7Days && usersNotActiveInLast7Days?.length > 0) {
            actionCards.push(
                <ListItem key="usersNotActive">
                    <ListItemIcon>
                        <Snooze />
                    </ListItemIcon>
                    <ListItemText
                        primary={
                            <FormattedMessage
                                id="dashboard.classroom.dash.havenotbeenactive"
                                defaultMessage="have not been active for 7 days">
                                {(userHaveNotBeenActiveFor7DaysText) =>
                                    usersNotActiveInLast7Days.length + ' ' + userHaveNotBeenActiveFor7DaysText
                                }
                            </FormattedMessage>
                        }
                    />
                    {showEngagementButtons && (
                        <ListItemSecondaryAction>
                            <Button variant="contained" disabled>
                                <FormattedMessage id="globalwords.encourage" defaultMessage="Encourage" />
                            </Button>
                        </ListItemSecondaryAction>
                    )}
                </ListItem>
            )
        }

        return actionCards
    }

    handleChange = (event, value, stateProp) => {
        this.setState({ [stateProp]: value })
    }

    removeDuplicates = (myArr, prop) => {
        return myArr.filter((obj, pos, arr) => {
            return arr.map((mapObj) => mapObj[prop]).indexOf(obj[prop]) === pos
        })
    }

    render() {
        const { classes, usergroup, user, organization, computedMatch } = this.props
        const { leaderBoardTab } = this.state
        const showEngagementButtons = user.organizationRole === 'admin'
        const showNotActiveLast7Days = user.organizationRole === 'admin'
        let actionPoints = this.createActionPoint(
            usergroup.userGroupStats,
            showEngagementButtons,
            showNotActiveLast7Days
        )

        let leaderboardUsers = usergroup?.userGroupStats?.users

        if (user.organizationRole !== 'admin') {
            leaderboardUsers = leaderboardUsers?.filter(
                (x) => !x.email.includes('@itsoundsgood.no') && !x.email.includes('@capeesh.com')
            )
        }

        var showLeaderboard = false
        var showActionPoints = true
        var currentOrganization = null
        if (organization.myOrganizations) {
            currentOrganization = organization.myOrganizations.find((x) => x.id === organization.selectedOrganization)
        }
        if (
            currentOrganization &&
            (user.organizationRole !== 'reporting' ||
                currentOrganization?.userStatisticsVisibility === UserStatisticsVisibility.SchoolMode)
        ) {
            showLeaderboard = true
        }

        const hideProgressionForStrictOrgAdmin =
            user.organizationRole === 'reporting' &&
            !user.classroomOnlyReportingUser &&
            currentOrganization?.userStatisticsVisibility === UserStatisticsVisibility.Strict

        let dayOfWeekUsageStats = []
        let showDayOfWeekUsageStats = false
        if (
            organization.graphDataDayOfWeekUserGroup &&
            organization.graphDataDayOfWeekUserGroup.userGroupId === computedMatch.params.classroomId &&
            organization.graphDataDayOfWeekUserGroup.canShowGraphData
        ) {
            dayOfWeekUsageStats = organization.graphDataDayOfWeekUserGroup.graphStatsDayOfWeekDtos.map((pie) => ({
                name: pie.dayOfWeekShort,
                value: pie.secondsCombined,
            }))
            showDayOfWeekUsageStats = true
        }

        let showTimeOfDayStats = false
        let timeOfDayStats = []
        let timeOfDayStatsIndex = {}
        if (
            organization.graphDataHourlyUserGroup &&
            organization.graphDataHourlyUserGroup.userGroupId === computedMatch.params.classroomId &&
            organization.graphDataHourlyUserGroup.canShowGraphData
        ) {
            timeOfDayStats = organization.graphDataHourlyUserGroup.graphStatsHourlyDtos
            timeOfDayStats.forEach((el, index) => (timeOfDayStatsIndex[el.hourOfTheDay] = el.minutesCombined))
            showTimeOfDayStats = true
        }

        return (
            <div className={classes.root}>
                <ClassroomSidebar userGroupId={computedMatch.params.classroomId} path={computedMatch.path} />
                <Grid container spacing={5} style={{ marginTop: '25px' }}>
                    <Grid item xs={12} sm={6}>
                        <Card>
                            <CardHeader
                                title={
                                    <FormattedMessage
                                        id="dashboard.classroom.dash.reporting"
                                        defaultMessage="Reporting"
                                    />
                                }
                            />
                            <CardContent>
                                <Button
                                    variant={'contained'}
                                    color={'primary'}
                                    disabled={
                                        user.organizationRole !== 'admin' &&
                                        user.organizationRole !== 'teacher' &&
                                        user.organizationRole !== 'reporting'
                                    }
                                    onClick={() => this.getClassroomExcelReportFromTemplate()}
                                    style={{ float: 'middle' }}>
                                    <FormattedMessage
                                        id="dashboard.classroom.dash.downloadexcelreport"
                                        defaultMessage="Download excel report"
                                    />
                                </Button>
                                {!hideProgressionForStrictOrgAdmin && (
                                    <Button
                                        variant={'contained'}
                                        color={'primary'}
                                        disabled={
                                            user.organizationRole !== 'admin' &&
                                            user.organizationRole !== 'teacher' &&
                                            user.organizationRole !== 'reporting'
                                        }
                                        onClick={() => this.openCourseGroupModal()}
                                        style={{ marginLeft: '10px' }}>
                                        <FormattedMessage
                                            id="dashboard.classroom.dash.coursegroupprogressionexport"
                                            defaultMessage="Course progression"
                                        />
                                    </Button>
                                )}
                            </CardContent>
                        </Card>
                    </Grid>
                    {showActionPoints && (
                        <Grid item xs={12} sm={6}>
                            <Card>
                                <CardHeader
                                    title={
                                        <FormattedMessage
                                            id="dashboard.classroom.dash.actionpointstitle"
                                            defaultMessage="Action points"
                                        />
                                    }
                                />
                                <CardContent>
                                    {actionPoints?.length > 0 ? (
                                        <List>{actionPoints.map((actionCard, index) => actionCard)}</List>
                                    ) : (
                                        <Typography variant="body2">
                                            <FormattedMessage
                                                id="dashboard.classroom.dash.noactionpoints"
                                                defaultMessage="No action points, all good!"
                                            />
                                        </Typography>
                                    )}
                                </CardContent>
                            </Card>
                        </Grid>
                    )}

                    <Grid item xs={12} sm={6}>
                        <DayOfTheWeekPieChart
                            dayOfWeekChartData={dayOfWeekUsageStats}
                            canShowChart={showDayOfWeekUsageStats}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <HourOfDayGraph
                            graphData={timeOfDayStats}
                            graphDataIndex={timeOfDayStatsIndex}
                            canShowChart={showTimeOfDayStats}
                            showYAxisLabel={false}
                        />
                    </Grid>

                    {showLeaderboard && (
                        <Grid item xs={12} sm={6}>
                            <Card>
                                <CardHeader
                                    title={
                                        <FormattedMessage
                                            id="dashboard.classroom.dash.leaderboard.title"
                                            defaultMessage="Leaderboards"
                                        />
                                    }
                                />
                                <CardContent>
                                    <Tabs
                                        value={leaderBoardTab}
                                        name="leaderBoardTab"
                                        onChange={(event, value) => this.handleChange(event, value, 'leaderBoardTab')}
                                        indicatorColor="primary"
                                        textColor="primary"
                                        centered>
                                        <Tab
                                            label={
                                                <FormattedMessage
                                                    id="globalwords.languagepoints"
                                                    defaultMessage="Language points"
                                                />
                                            }
                                        />
                                        <Tab
                                            label={
                                                <FormattedMessage id="globalwords.activity" defaultMessage="Activity" />
                                            }
                                        />
                                    </Tabs>
                                    {leaderBoardTab === 0 && (
                                        <List>
                                            {leaderboardUsers &&
                                                leaderboardUsers
                                                    .sort((a, b) => b.experience - a.experience)
                                                    .slice(0, 5)
                                                    .map((user, index) => (
                                                        <ListItem key={index}>
                                                            <ListItemAvatar>
                                                                <Avatar className={classes.leaderBoardIndex}>
                                                                    {index + 1}
                                                                </Avatar>
                                                            </ListItemAvatar>
                                                            <ListItemText
                                                                primary={
                                                                    user.name +
                                                                    ' (' +
                                                                    user.experience.toLocaleString() +
                                                                    'LP)'
                                                                }
                                                            />
                                                        </ListItem>
                                                    ))}
                                        </List>
                                    )}
                                    {leaderBoardTab === 1 && (
                                        <List>
                                            {leaderboardUsers &&
                                                leaderboardUsers
                                                    .sort((a, b) => new Date(b.lastActive) - new Date(a.lastActive))
                                                    .slice(0, 5)
                                                    .map((user, index) => (
                                                        <ListItem key={index}>
                                                            <ListItemAvatar>
                                                                <Avatar className={classes.leaderBoardIndex}>
                                                                    {index + 1}
                                                                </Avatar>
                                                            </ListItemAvatar>
                                                            <ListItemText primary={user.name} />
                                                        </ListItem>
                                                    ))}
                                        </List>
                                    )}
                                </CardContent>
                            </Card>
                        </Grid>
                    )}
                </Grid>

                <Dialog
                    open={this.state.courseGroupModalOpen}
                    onClose={this.closeCourseGroupModal}
                    fullWidth
                    maxWidth="md">
                    <DialogTitle>
                        <FormattedMessage
                            id="dashboard.classroom.dash.selectcoursegroupsforexport"
                            defaultMessage="Select course groups to export"
                        />
                    </DialogTitle>
                    <DialogContent>
                        <div style={{ marginBottom: '16px' }}>
                            <Typography variant="subtitle2" style={{ marginBottom: '8px' }}>
                                <FormattedMessage id="dashboard.export.daterange" defaultMessage="Date range (optional)" />
                            </Typography>
                            <div style={{ display: 'flex', gap: '8px', marginBottom: '8px', flexWrap: 'wrap' }}>
                                {[
                                    { key: 'all', label: 'All time' },
                                    { key: '7d', label: 'Last 7 days' },
                                    { key: '30d', label: 'Last 30 days' },
                                    { key: '90d', label: 'Last 90 days' },
                                    { key: 'year', label: 'This year' },
                                ].map((preset) => (
                                    <Chip
                                        key={preset.key}
                                        label={preset.label}
                                        clickable
                                        color={this.state.selectedDatePreset === preset.key ? 'primary' : 'default'}
                                        variant={this.state.selectedDatePreset === preset.key ? 'default' : 'outlined'}
                                        onClick={() => this.handleDatePreset(preset.key)}
                                    />
                                ))}
                            </div>
                            <div style={{ display: 'flex', gap: '12px' }}>
                                <TextField
                                    label="From"
                                    type="date"
                                    value={this.state.exportFromDate}
                                    onChange={(e) => this.setState({ exportFromDate: e.target.value, selectedDatePreset: 'custom' })}
                                    InputLabelProps={{ shrink: true }}
                                    size="small"
                                    style={{ width: '180px' }}
                                />
                                <TextField
                                    label="To"
                                    type="date"
                                    value={this.state.exportToDate}
                                    onChange={(e) => this.setState({ exportToDate: e.target.value, selectedDatePreset: 'custom' })}
                                    InputLabelProps={{ shrink: true }}
                                    size="small"
                                    style={{ width: '180px' }}
                                />
                            </div>
                        </div>
                        {organization.fetchingCourseGroups ? (
                            <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                                <CircularProgress />
                            </div>
                        ) : (
                            <div>
                                {organization.organizationCourseGroups?.length > 0 && (
                                    <div style={{ marginBottom: '12px' }}>
                                        <Button variant="outlined" size="small" onClick={this.handleToggleSelectAll}>
                                            {this.state.selectedCourseGroupIds.length === organization.organizationCourseGroups.length ? (
                                                <FormattedMessage id="globalwords.deselectall" defaultMessage="Deselect all" />
                                            ) : (
                                                <FormattedMessage id="globalwords.selectall" defaultMessage="Select all" />
                                            )}
                                        </Button>
                                    </div>
                                )}
                                {organization.organizationCourseGroups?.map((courseGroup, index) => (
                                    <div key={courseGroup.id} style={{ marginBottom: '8px' }}>
                                        <CourseGroupCard
                                            courseGroup={courseGroup}
                                            index={index}
                                            handleCheckMarkCourseGroup={this.handleToggleCourseGroup}
                                            checked={this.state.selectedCourseGroupIds.includes(courseGroup.id)}
                                        />
                                    </div>
                                ))}
                                {(!organization.organizationCourseGroups || organization.organizationCourseGroups.length === 0) && (
                                    <Typography variant="body2">
                                        <FormattedMessage
                                            id="dashboard.classroom.dash.nocoursegroupsavailable"
                                            defaultMessage="No course groups available."
                                        />
                                    </Typography>
                                )}
                            </div>
                        )}

                        <div style={{ marginTop: '20px' }}>
                            <Typography variant="subtitle2" style={{ marginBottom: '4px' }}>
                                <FormattedMessage id="globalwords.export.columns" defaultMessage="Columns" />
                            </Typography>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.includePassedColumn}
                                        onChange={(event) =>
                                            this.setState({ includePassedColumn: event.target.checked })
                                        }
                                        color="primary"
                                        size="small"
                                    />
                                }
                                label={
                                    <FormattedMessage id="globalwords.export.column.passed" defaultMessage="Passed" />
                                }
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.includeClassroomColumn}
                                        onChange={(event) =>
                                            this.setState({ includeClassroomColumn: event.target.checked })
                                        }
                                        color="primary"
                                        size="small"
                                    />
                                }
                                label={
                                    <FormattedMessage
                                        id="globalwords.export.column.classroom"
                                        defaultMessage="Classroom"
                                    />
                                }
                            />
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.closeCourseGroupModal}>
                            <FormattedMessage id="globalwords.cancel" defaultMessage="Cancel" />
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            disabled={this.state.selectedCourseGroupIds.length === 0 || organization.isExportingClassroomProgression}
                            onClick={this.handleExportCourseGroupProgression}>
                            {organization.isExportingClassroomProgression ? (
                                <CircularProgress size={24} color="inherit" />
                            ) : (
                                <FormattedMessage id="globalwords.download" defaultMessage="Download" />
                            )}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

ClassroomDashboard.propTypes = {
    classes: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
}

function mapStateToProps(state) {
    const { organization, usergroup, user } = state
    return {
        user,
        organization,
        usergroup,
    }
}

const enhance = compose(connect(mapStateToProps), withStyles(styles), withRouter)

export default enhance(ClassroomDashboard)
